import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../store/service'

export const getBusinessSize = createAsyncThunk(
  'portfolioInsights/segment/businessDistribution/getBusinessSize',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getBusinessSize(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportBusinessSize = createAsyncThunk(
  'portfolioInsights/segment/businessDistribution/exportBusinessSize',
  async (params) => {
    const response = await Service.exportBusinessSize(params)
    handleExport(response.data, response.filename)
  },
)
